export const FREQUENCY_COLUMN_HEADING = 'Frequency';
export const TOTAL_COLUMN_HEADING = 'Total monthly';
